import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  root: {
    height: 44,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/GoogleAuthButton/useStyles.js